export default "__VITE_ASSET__B3iZ61e___"